export default "__VITE_ASSET__7f2511bc__"